// DHI EUM unit names encode ?
// "eumUm2SecPerDegree" vs "eumUm2SecPerRad" for wave energy density. Which
export const isPerDegreeUnit = (unit: string): boolean => /perdeg/i.test(unit);
